export { ForgottenPasswordV2 } from './ForgottenPasswordV2';
